var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16699 10.0001C2.16699 5.39771 5.89795 1.66675 10.5003 1.66675C15.1027 1.66675 18.8337 5.39771 18.8337 10.0001C18.8337 14.6024 15.1027 18.3334 10.5003 18.3334C5.89795 18.3334 2.16699 14.6024 2.16699 10.0001ZM10.5003 4.66443C10.8455 4.66443 11.1253 4.94426 11.1253 5.28943V6.00891C11.8392 6.14747 12.4685 6.52089 12.8616 7.06441C13.0638 7.34413 13.001 7.73485 12.7213 7.93711C12.4416 8.13936 12.0508 8.07657 11.8486 7.79686C11.6127 7.47069 11.1229 7.19916 10.5003 7.19916H10.2624C9.41908 7.19916 8.98416 7.72397 8.98416 8.09679V8.16216C8.98416 8.448 9.19216 8.80366 9.68849 9.00225L11.7763 9.83733C12.625 10.1767 13.2665 10.9209 13.2665 11.838C13.2665 13.0212 12.2562 13.8352 11.1253 14.0139V14.7107C11.1253 15.0559 10.8455 15.3357 10.5003 15.3357C10.1552 15.3357 9.87533 15.0559 9.87533 14.7107V13.9912C9.16141 13.8527 8.53213 13.4792 8.13911 12.9357C7.93685 12.656 7.99964 12.2653 8.27936 12.0631C8.55908 11.8608 8.94983 11.9236 9.15208 12.2033C9.38791 12.5295 9.87774 12.801 10.5003 12.801H10.6565C11.545 12.801 12.0165 12.2469 12.0165 11.838C12.0165 11.5522 11.8085 11.1965 11.3122 10.9979L9.22433 10.1628C8.3757 9.82341 7.73413 9.07925 7.73413 8.16216V8.09679C7.73413 6.92227 8.75595 6.12648 9.87533 5.97532V5.28943C9.87533 4.94426 10.1552 4.66443 10.5003 4.66443Z",
    fill: "#CA8501"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.997312eaede91e574e99200c655ebcca.svg";
export { ForwardRef as ReactComponent };